import React, { memo } from 'react';
import styles from './Experience.module.scss';

const Experience = memo(
    ({
        experienceList,
        onExperienceChangeHandler,
        handleKeyDown,
        onDeleteExperienceHandler
    }) => {
        return (
            <ul className="list-unstyled">
                {experienceList.map((experience, experienceIndex) => (
                    <li
                        key={experienceIndex}
                        className={`${styles.ListItem} row`}>
                        <div className="col-12 form-group">
                            <input
                                type="text"
                                name="workPosition"
                                placeholder="Position"
                                value={experience.position}
                                onChange={(event) =>
                                    onExperienceChangeHandler(
                                        event,
                                        experienceIndex,
                                        'position'
                                    )
                                }
                                className={`${styles.ListItemInput} ${styles.WorkPosition} form-control`}
                            />
                        </div>
                        <div className="col-12 form-group">
                            <input
                                type="text"
                                name="workName"
                                placeholder="Enterprise name"
                                value={experience.company}
                                onChange={(event) =>
                                    onExperienceChangeHandler(
                                        event,
                                        experienceIndex,
                                        'company'
                                    )
                                }
                                className={`${styles.ListItemInput} ${styles.WorkCompanyName} form-control`}
                            />
                        </div>
                        <div className="col-auto form-group">
                            <input
                                type="text"
                                name="workStartDate"
                                placeholder="2013-01"
                                value={experience.startDate}
                                onChange={(event) =>
                                    onExperienceChangeHandler(
                                        event,
                                        experienceIndex,
                                        'startDate'
                                    )
                                }
                                className={`${styles.ListItemInput} ${styles.WorkDate} form-control`}
                                style={{
                                    width: '100px'
                                }}
                            />
                        </div>
                        <div className="col-auto form-group">
                            <input
                                type="text"
                                name="workEndDate"
                                placeholder="2014-01"
                                value={experience.endDate}
                                onChange={(event) =>
                                    onExperienceChangeHandler(
                                        event,
                                        experienceIndex,
                                        'endDate'
                                    )
                                }
                                className={`${styles.ListItemInput} ${styles.WorkDate} form-control`}
                                style={{
                                    width: '100px'
                                }}
                            />
                        </div>
                        <div
                            className={`col-12 form-group ${styles.ListItemTextareaWrapper}`}>
                            <textarea
                                placeholder="Description"
                                onKeyDown={handleKeyDown}
                                onChange={(event) => {
                                    handleKeyDown(event);
                                    onExperienceChangeHandler(
                                        event,
                                        experienceIndex,
                                        'description'
                                    );
                                }}
                                value={experience.description}
                                className={`${styles.ListItemTextarea} form-control`}></textarea>
                        </div>
                        <div className="col-auto">
                            <button
                                onClick={() =>
                                    onDeleteExperienceHandler(experienceIndex)
                                }
                                className={`${styles.DeleteListItem} btn btn-outline-danger`}>
                                ×
                            </button>
                        </div>
                    </li>
                ))}
            </ul>
        );
    }
);

export default Experience;
